export default __webpack_public_path__ + "static/media/export-key-visual.3647d415.svg";